import { emailStepStore } from "@entities/StepEmail/store/emailStepStore";
import { getAuthToken, setAuthToken } from "./Auth";
import {
	AnalyticsApi,
	AuthApi,
	Configuration,
	ConfigurationParameters, DataConnectionsApi,
	FtlIntegrationApi,
	FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest,
	FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse,
	InfoApi,
	NativeApi,
	ProfileApi, PromoCodeApi,
	PublicGameConfigApi,
	StoreApi,
	SupportApi
} from "./gen";
import { appStore } from "@/app/store/appStore";

//let currentAuthToken: string | undefined;

//export function getAuthToken() {
//	return currentAuthToken;
//}

//export function setAuthToken(token: string) {
//	console.log('Setting new auth token to %o', token);
//	currentAuthToken = token;
//}

export const config: ConfigurationParameters = {
	basePath: "https://id-dev.fx.gl",
	headers: {
		"Access-Control-Allow-Headers": "Content-Type",
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "OPTIONS,POST,GET"
	},
	accessToken: () => getAuthToken() as string
};

if (import.meta.env.BASE_URL !== "/") {
	const url = new URL(import.meta.url || "https://id-dev.fx.gl");
	console.log("URL", url);
	config.basePath = `${url.protocol}//${url.hostname}:${url.port}`;
	//config.basePath = 'http://localhost:5173/';
	// config.basePath = 'https://id-dev.fx.gl';
	console.log("config.basePath", config.basePath);
}

export const openApiConfig: Configuration = new Configuration(config);

const OpenApiClient = {
	Auth: new AuthApi(openApiConfig),
	Profile: new ProfileApi(openApiConfig),
	PublicGameConfigApi: new PublicGameConfigApi(openApiConfig),
	NativeApi: new NativeApi(new Configuration(config)),
	Info: new InfoApi(openApiConfig),
	FtlIntegration: new FtlIntegrationApi(openApiConfig),
	Analytics: new AnalyticsApi(openApiConfig),
	Store: new StoreApi(openApiConfig),
	Support: new SupportApi(openApiConfig),
	PromoCode: new PromoCodeApi(openApiConfig),
	DataConnections: new DataConnectionsApi(openApiConfig)
};

export function isDevelopmentServer(): boolean {
	return appStore.getState().gameConfig.PublicWebClientConfig.Launcher?.DevelopmentMode === true;
}

export function isPreinstall(): boolean {
	return emailStepStore.getState().isExternalLogin;
}

export const AuthenticateUser = async (
	payload: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest,
	gameCode: string
): Promise<FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse> => {
	const data = await OpenApiClient.Auth.fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint(gameCode, payload);
	if (data.Tokens?.AccessToken) {
		// config.accessToken = data.Tokens?.AccessToken;
		setAuthToken(data.Tokens.AccessToken);
	}

	return data;
};

export default OpenApiClient;
